import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SwalService } from '@shared/utils/swal.service';
import { DestinoService } from './services/destino.service';
import { IDestino, IDestinoRequest } from './interfaces/destino.interface';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-destinos',
  templateUrl: './destinos.component.html',
  providers: [ConfirmationService, MessageService]
})
export class DestinosComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayedColumns: Column[] = [
    { field: 'destino', header: 'Clave' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'actions', header: 'Acciones' }
  ];

  public loading: boolean = true;
  public dataSource: IDestino[] = [];
  public globalFilter: string = '';
  public first: number = 0;
  public rows: number = 10;
  public totalRecords: number = 0;

  displayDialog: boolean = false;
  selectedDestino: IDestino | null = null;

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private swalService: SwalService,
    private destinoService: DestinoService
  ) {}

  ngOnInit(): void {
    this.read();
  }

  read() {
    this.loading = true;
    const request: IDestinoRequest = {
      que: 4,
      tope: '999',
      clave: '',
      descripcion: ''
    };

    this.destinoService.getDestinos(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los destinos'
          });
        }
      },
      error: (error) => {
        console.error('Error al cargar destinos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los destinos'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate() {
    this.selectedDestino = null;
    this.displayDialog = true;
  }

  openUpdate(model: IDestino) {
    this.selectedDestino = model;
    this.displayDialog = true;
  }

  onDialogClosed(event?: {refresh: boolean, clave?: string, success?: boolean}) {
    this.displayDialog = false;
    if (event) {
      if (event.success === true) {
        this.messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Destino guardado correctamente'
        });
      } else if (event.success === false) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo guardar el destino'
        });
      }
      if (event.refresh && event.clave) {
        this.readAndFilterByClave(event.clave);
      } else if (event.refresh) {
        this.read();
      }
    }
  }

  readAndFilterByClave(clave: string) {
    this.loading = true;
    const request: IDestinoRequest = {
      que: 4,
      tope: '999',
      clave: '',
      descripcion: ''
    };
    this.destinoService.getDestinos(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data.filter(d => d.destino === clave);
          this.totalRecords = this.dataSource.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los destinos'
          });
        }
      },
      error: (error) => {
        console.error('Error al cargar destinos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los destinos'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  delete(model: IDestino) {
    import('sweetalert2').then(Swal => {
      Swal.default.fire({
        title: '¿Está seguro?',
        text: `¿Está seguro de eliminar el destino ${model.destino}?`,
        icon: 'warning',
        showCancelButton: true,
        iconColor: "#d33",
        confirmButtonColor: "#d33",
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'No',
        heightAuto: false
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.loading = true;
          const request: IDestinoRequest = {
            que: 3, // Eliminar
            tope: '1',
            clave: model.destino,
            descripcion: model.descripcion
          };
          this.destinoService.getDestinos(request).subscribe({
            next: (response) => {
              if (response.success) {
                this.globalFilter = '';
                if (this.table) this.table.clear();
                this.messageService.add({
                  severity: 'success',
                  summary: 'Éxito',
                  detail: 'Destino eliminado correctamente'
                });
                this.read();
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Error al eliminar el destino'
                });
              }
            },
            error: (error) => {
              console.error('Error al eliminar destino:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el destino'
              });
            },
            complete: () => {
              this.loading = false;
            }
          });
        }
      });
    });
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
  }

  onFilter(event: any): void {
    this.globalFilter = event.filteredValue;
  }
} 